var catalogue = require('./catalogue.js');

angular.module('messages', [])
    .service('toastArgs', function () {
        var toastArgs = {};
        var userArgs = null;
        var defaultDelay = 3000;
        var toast_num = 0;

        function HideToast() {
            var el = document.getElementById('ms-toast');
            if (el) {
                el.style.display = 'none';
            }
            toastArgs.toastVisible = false;
        }

        return {
            hideToast: HideToast,

            /**
             * @param content {String}
             * @param [delay] {Number|null} - in milliseconds, set to null for defaultDelay, -1 = endless
             * @param [template] {String} - path
             * @param [args] {{}}
             */
            showToast: function (content, delay, template, args) {
                if (!delay) delay = defaultDelay;

                toast_num += 1;
                toastArgs.message = content;
                toastArgs.toastVisible = true;

                toastArgs.template = template ? template : 'toasts/default.html';
                userArgs = args;
                document.getElementById('ms-toast').style.display = '';

                function _some(delay, numb) {
                    setTimeout(function () {
                        if (toast_num === numb) HideToast();
                    }, delay)
                }

                if (delay != -1) {
                    _some(delay, toast_num)
                }
            },

            isVisible: function () {
                return toastArgs.toastVisible;
            },

            getArg: function (key) {
                return userArgs ? userArgs[key] : null;
            },

            getMessage: function () {
                return toastArgs.message;
            },

            getTemplate: function () {
                return toastArgs.template;
            }
        };
    })

    .controller('ToastCtrl', ['$scope', '$mdToast', 'toastArgs', '$animate', function ($scope, $mdToast, toastArgs, $animate) {
        $scope.toastArgs = toastArgs;
        $animate.enabled(angular.element(document.getElementById('ms-toast')), false);
        $scope.closeToast = function () {
            toastArgs.hideToast();
        };
    }])

    .value('catalogue', catalogue)
    .service('messages', ['$window', '$document', '$mdToast', 'toastArgs', function ($window, $document, $mdToast, toastArgs) {

        var delay = 3000;
        var toast_num = 0;

        return {
            hide: function () {
                var tmp = toast_num;
                setTimeout(function () {
                    // hide the toast only if it is the same toast after 20ms
                    if (toast_num == tmp) {
                        toastArgs.hideToast();
                    }
                }, 20);
            },

            /**
             * @param message_key
             * @param dict
             * @param delay
             * @param args
             * @param template {String} - path
             */
            custom: function (message_key, dict, delay, args, template) {
                toastArgs.showToast(catalogue.get(message_key, dict), delay, template, args);
                toast_num += 1;
            },

            /**
             * @param {string} message_key - the catalogue key to get the message
             * @param {Object.<string, string>} [dict] - optional: replace %key% with value
             */
            notify: function (message_key, dict) {
                toastArgs.showToast(catalogue.get(message_key, dict), delay);
                toast_num += 1;
            },

            /**
             * @param message_key {string} - the catalogue key to get the message
             * @param {Object.<string, string>} [dict] - optional: replace %key% with value
             */
            show: function (message_key, dict) {
                toastArgs.showToast(catalogue.get(message_key, dict), -1);
                toast_num += 1;
            }
        };
    }]);

